import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CrudActions } from '../actions';

import DeleteDialog from '../components/dialogs/DeleteDialog';

//export default (type) => (DecoratedComponent) =>{
import Context from 'managers/Context';

export default (DecoratedComponent) => {
    function mapDispatchToProps(dispatch) {
        return {
            showDeleteCrud: bindActionCreators(CrudActions, dispatch).showDeleteCrud,
        };
    }

    function mapStateToProps(state) {
        return {
            entityCrud: state.crud.entityCrud,
            entityType: state.crud.entityType,
        };
    }

    let component = class extends Component {
        handleTouchTap = (event) => {
            event.preventDefault();
            let { showDeleteCrud, entityCrud, entityType } = this.props;
            let model = Context.entityManager.getModel(entityType);
            showDeleteCrud(entityType, model.fromCrud(entityCrud), true);
        };

        render() {
            const { entityCrud } = this.props;
            let result;
            if (entityCrud && entityCrud.get('id')) {
                result = (
                    <div>
                        <DecoratedComponent {...this.props} onClick={this.handleTouchTap} />
                        <DeleteDialog />
                    </div>
                );
            } else {
                result = null;
            }
            return result;
        }
    };

    component.propTypes = {
        id: PropTypes.string,
    };

    return connect(mapStateToProps, mapDispatchToProps)(component);
};
